import { RectangleElementDto } from "@repo/api/overlays";
import { getHexWithOpacity } from "../../utils/color.ts";

type Props = {
  element: RectangleElementDto;
};

export default function RectangleElement({ element }: Props) {
  const hexWithOpacity = getHexWithOpacity(
    element.backgroundColor.color,
    element.backgroundColor.opacity ?? 100,
  );

  return (
    <div
      className="h-full w-full"
      style={{
        backgroundColor: hexWithOpacity,
      }}
    />
  );
}
